import * as types from './types'
import {
  APIResponse,
  DELETEResponse,
  GetInvoiceSequencesResponse,
  InvoiceSequence,
  InvoiceSequenceResponse,
  UUIDResponse
} from '@cbgms/api'
import { IPaginatedRequest } from '@cbgms/api/request'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadInvoiceSequences = (params: IPaginatedRequest = {}) =>
  AsyncAction<GetInvoiceSequencesResponse>({
    type: [types.LOAD_INVOICE_SEQUENCES, types.LOAD_INVOICE_SEQUENCES_SUCCESS, types.LOAD_INVOICE_SEQUENCES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/invoices/sequences',
        params
      }
    }
  })

export const getInvoiceSequence = (invoiceSequenceUUID: string) =>
  AsyncAction<InvoiceSequenceResponse>({
    type: [types.LOAD_INVOICE_SEQUENCE, types.LOAD_INVOICE_SEQUENCE_SUCCESS, types.LOAD_INVOICE_SEQUENCE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/invoices/sequences/${invoiceSequenceUUID}`
      }
    }
  })

export const createInvoiceSequence = (data: Partial<InvoiceSequence>) =>
  AsyncAction<UUIDResponse>({
    type: [types.CREATE_INVOICE_SEQUENCE, types.CREATE_INVOICE_SEQUENCE_SUCCESS, types.CREATE_INVOICE_SEQUENCE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'POST',
        url: '/modules/invoices/sequences',
        data
      }
    }
  })

export const updateInvoiceSequence = (invoiceSequenceUUID: string, data: Partial<InvoiceSequence>) =>
  AsyncAction<UUIDResponse>({
    type: [types.UPDATE_INVOICE_SEQUENCE, types.UPDATE_INVOICE_SEQUENCE_SUCCESS, types.UPDATE_INVOICE_SEQUENCE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'PUT',
        url: `/modules/invoices/sequences/${invoiceSequenceUUID}`,
        data
      }
    }
  })

export const testInvoiceSequencePattern = (pattern: string, year: number) =>
  AsyncAction<APIResponse<string>>({
    type: [types.TEST_INVOICE_SEQUENCE, types.TEST_INVOICE_SEQUENCE_SUCCESS, types.TEST_INVOICE_SEQUENCE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: `/modules/invoices/sequences/test/${pattern}`,
        params: {
          year
        }
      }
    }
  })

export const deleteInvoiceSequence = (uuid: string, DryRun: boolean) =>
  AsyncAction<DELETEResponse>({
    type: [types.DELETE_INVOICE_SEQUENCE, types.DELETE_INVOICE_SEQUENCE_SUCCESS, types.DELETE_INVOICE_SEQUENCE_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'DELETE',
        url: `/modules/invoices/sequences/${uuid}`,
        params: {
          DryRun
        }
      }
    }
  })
